import { render } from "./FilterRole.vue?vue&type=template&id=06b858a8"
import script from "./FilterRole.vue?vue&type=script&lang=js"
export * from "./FilterRole.vue?vue&type=script&lang=js"
script.render = render

export default script